module.exports = __webpack_public_path__ + "static/DSC_9359-51f5b92b30ed7ebd378c044056762dbb.jpg";